<template>
  <div class="page page--fill">
    <data-list
      ref="list"
      title="Abonnements"
      :resource="resource"
      :columns="columns">
      <template #actions>
        <v-btn
          color="primary"
          depressed
          :to="{ name: 'newPlan' }">
          <v-icon
            left
            small>
            mdi-plus
          </v-icon>
          Nouvel abonnement
        </v-btn>
      </template>
      <template #name="{ item }">
        <span class="cell-strong">{{ item.name }}</span>
      </template>
      <template #account_type="{ item }">
        <span :class="pillClass(ACCOUNT_TYPE, item.account_type)">{{ labelOf(ACCOUNT_TYPE, item.account_type) }}</span>
      </template>
      <template #options="{ item }">
        <span
          v-for="option in options"
          v-show="item[option.key]"
          :key="option.key"
          class="pill mr-1">{{ option.label }}</span>
      </template>
      <template #available="{ item }">
        <span :class="['pill', item.available ? 'pill--success' : '']">{{ item.available ? 'Disponible' : 'Masqué' }}</span>
      </template>
      <template #row_actions="{ item }">
        <div class="d-flex justify-end">
          <v-btn
            icon
            small
            title="Modifier"
            @click.stop="editPlan(item)">
            <v-icon small>
              mdi-pencil-outline
            </v-icon>
          </v-btn>
          <v-btn
            icon
            small
            title="Supprimer"
            @click.stop="deletePlan(item)">
            <v-icon
              small
              color="error">
              mdi-trash-can-outline
            </v-icon>
          </v-btn>
        </div>
      </template>
    </data-list>

    <v-dialog
      :value="!!editedItem"
      max-width="560"
      @input="$event || (editedItem = null)">
      <v-card v-if="editedItem">
        <v-card-title>Modifier l'abonnement</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="editedItem.name"
            label="Nom"
            outlined
            dense />
          <v-select
            v-model="editedItem.account_type"
            :items="accountTypes"
            label="Type de compte"
            outlined
            dense />
          <div class="plan-switches">
            <v-switch
              v-model="editedItem.available"
              label="Disponible"
              inset
              dense
              hide-details />
            <v-switch
              v-for="option in options"
              :key="option.key"
              v-model="editedItem[option.key]"
              :label="option.label"
              inset
              dense
              hide-details />
          </div>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer />
          <v-btn
            text
            @click="editedItem = null">
            Annuler
          </v-btn>
          <v-btn
            color="primary"
            depressed
            @click="updatePlan">
            Enregistrer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import RESOURCES from '@batimentb/vadimm-js-api/resources'
  import DataList from '../components/DataList'
  import { ACCOUNT_TYPE, toOptions, pillClass, labelOf } from '../labels'

  export default {
    name: 'PlanList',
    components: { DataList },
    data () {
      return {
        ACCOUNT_TYPE,
        resource: RESOURCES.PLAN,
        editedItem: null,
        accountTypes: toOptions(ACCOUNT_TYPE),
        options: [
          { key: 'free_plan', label: 'Gratuit' },
          { key: 'can_add_users', label: 'Ajout d\'utilisateurs' },
          { key: 'calendar_enabled', label: 'Calendrier' },
          { key: 'adv_enabled', label: 'ADV' },
          { key: 'stats_enabled', label: 'Stats' }
        ],
        columns: [
          { key: 'name', label: 'Abonnement' },
          { key: 'account_type', label: 'Type de compte', width: 170 },
          { key: 'options', label: 'Options' },
          { key: 'available', label: 'Statut', width: 120 },
          { key: 'row_actions', label: '', width: 90, align: 'end' }
        ]
      }
    },
    methods: {
      pillClass,
      labelOf,
      editPlan (plan) {
        this.editedItem = { ...plan }
      },
      async updatePlan () {
        try {
          await this.$api.put(RESOURCES.PLAN, this.editedItem.pk, this.editedItem)
          this.$awn.success('Abonnement mis à jour')
          this.editedItem = null
          this.$refs.list.reload()
        } catch (e) {
          if (e.message !== 'Action annulée') this.$awn.alert('Impossible de mettre à jour l\'abonnement')
        }
      },
      async deletePlan (plan) {
        const ok = await this.$confirm({
          title: 'Supprimer l\'abonnement ?',
          message: `L'abonnement « ${plan.name} » sera supprimé.`,
          confirmLabel: 'Supprimer',
          danger: true
        })
        if (!ok) return
        try {
          await this.$api.delete(RESOURCES.PLAN, plan.pk)
          this.$awn.success('Abonnement supprimé')
          this.$refs.list.reload()
        } catch (e) {
          if (e.message !== 'Action annulée') this.$awn.alert('Impossible de supprimer cet abonnement')
        }
      }
    }
  }
</script>

<style scoped>
  .plan-switches {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 4px 16px;
  }
</style>
